import { Component } from "react"

/* Link */
import { Link } from "react-router-dom"

/* Components */
import { Icon } from "../../components"

/* Helpers */
import { withRouter } from "../../helpers"


/* The sections a lost administrator most likely wanted */
const LINKS = [
    { text: "Записи", link: "/booking", icon: "booking" },
    { text: "Организации", link: "/organization", icon: "organization" },
    { text: "Пользователи", link: "/user", icon: "user" },
    { text: "Жалобы", link: "/support", icon: "support" },
    { text: "Транзакции", link: "/transaction", icon: "wallet" }
]


/* Page 404 — an address the panel does not know. It says which one, and gives the ways back */
class Page404 extends Component {

    render = () => {

        /* Fields */
        const { location, navigate } = this.props

        return (
            <div className="page-404">
                <div className="page-404-box">

                    <div className="page-404-art">
                        <div className="page-404-glow" />
                        <div className="page-404-orbit outer"><i /></div>
                        <div className="page-404-orbit inner"><i /></div>
                        <div className="page-404-number">404</div>
                    </div>

                    <h1>Такой страницы нет</h1>
                    <p>Возможно, ссылка устарела или в адресе опечатка. Раздел мог переехать — загляните в меню.</p>

                    {location && location.pathname && <div className="page-404-path">{location.pathname}</div>}

                    <div className="page-404-actions">
                        <Link to="/" className="page-404-button">
                            <Icon name="dashboard" size={17} width={2} />
                            На главную
                        </Link>
                        <div onClick={() => navigate(-1)} className="page-404-button light">
                            <Icon name="left" size={17} width={2} />
                            Назад
                        </div>
                    </div>

                    <div className="page-404-links">
                        {LINKS.map(item =>
                            <Link key={item.link} to={item.link}>
                                <Icon name={item.icon} size={15} width={2} />
                                {item.text}
                            </Link>
                        )}
                    </div>

                </div>
            </div>
        )
    }
}

export default withRouter(Page404)
